import { state, style, trigger } from '@angular/animations';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LocaleService } from 'src/app/shared/services/translate.service';
import { SidenavService } from 'src/app/shared/sidenav-bar/sidenav.service';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    animations: [
        trigger('changeDivSize', [
            state('textBlink', style({
                color: 'green',
            })),
        ]),
        trigger('blinker', [
            state('on', style({
                animationName: 'blinker',
                animationIterationCount: 'infinite',
                animationTimingFunction: 'cubic-bezier(1,0,0,1)',
                animationDuration: '1s',
                //Basic styling
                display: 'inline-block',
                width: '2px',
                height: '50px',
                marginLeft: '5px',
                borderRadius: '3px',
                background: 'green',
            })),
            // transition("void <=> *", animate(1000))
        ]),
    ],
    standalone: false
})
export class SignInComponent implements OnInit {



  loginParams: any;
  show: boolean = false;
  selectedWorkspaceId: any;
  isBrowser: any;
  routerSubscription: any;
  routerSubscriptionParams: any;
  constructor(
    public sidenavService: SidenavService,
    public translate: TranslateService,
    private localeService: LocaleService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId?: Object,
    @Inject(DOCUMENT) private document?: Document
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
      this.translate.use(this.localeService.currentLocale);
   }

  textBlink = 'textBlink';
  blinker = 'on';
  typewriter_text: string = `brilliant`;
  typewriter_texts: any = [`brilliant`, `smart`, `successful`, `amazing`];
  changing_qoute: string = `guest.Your apps work together`;
  changing_qoutes: string[] = [
    `guest.Your apps work together`,
    `guest.You visually build your solution`,
    `guest.Your apps integrate seemlessly`,
    `guest.You are on control of systems`,
  ];
  typewriter_display: string = '';


  ngOnInit(): void {

    this.routerSubscription = this.route.params.subscribe(routeData => {
      console.log("routeData", routeData);
      if(routeData.origin && routeData.origin == 'mobile'){
        this.loginParams = routeData;
      }
    })

    if(!this.isBrowser) return;
    this.routerSubscriptionParams = this.route.queryParams.subscribe(async params => {
      if(params.origin && params.origin == 'mobile'){
        this.loginParams = params;
      }
      if(params.selected_workspace) this.selectedWorkspaceId = params.selected_workspace;
      console.log("params", params);
    })


    console.log(this.translate.currentLang)
    this.localeService.localeChangeEvent.subscribe(lang => this.translate.use(lang));
    this.typingCallback(this);
    this.changingQouteCallback(this);
    console.log(this.typewriter_texts)
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      console.log(event)
      this.typewriter_texts = Object.values(this.translate
        .instant([`brilliant`, `smart`, `successful`, `amazing`]));
    });

  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.routerSubscriptionParams?.unsubscribe();
  }

  changeTextForTypingCallback(that) {
    let randomNumber = Math.floor(Math.random() * that.typewriter_texts.length);
    that.typewriter_text = that.typewriter_texts[randomNumber];
    that.typingCallback(that);
  }

  changingQouteCallback(that: this) {
    let randomNumber = Math.floor(Math.random() * that.changing_qoutes.length);
    that.changing_qoute = that.changing_qoutes[randomNumber];
    setTimeout(that.changingQouteCallback, 3000, that);
  }


  typingCallback(that) {
    let total_length = that.typewriter_text.length;
    let current_length = that.typewriter_display.length;
    if (current_length < total_length) {
      that.typewriter_display += that.typewriter_text[current_length];
      setTimeout(that.typingCallback, 300, that);
    } else {
      setTimeout(
        () => {
          that.typewriter_display = '';
        },
        1500,
        that
      );
      setTimeout(that.changeTextForTypingCallback, 2000, that);
    }
  }
}
